// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.answer__content{
    padding: 0.625em 1.25em;
    border-radius: 1.5em 1.5em 0 0;
    background: #161616;
}
.answer__top{
    display: flex;
    align-items: center;
    margin-bottom: 1em;
}
.answer__ava{
    position: relative;
    border-radius: 100%;
    background: #D7D3F1;
    width: 5.875em;
    height: 5.875em;
    flex-shrink: 0;
    margin-right: 1.2em;
}
.answer__avaIco{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%; 
}
.answer__name{
    font-weight: 500;
    font-size: 1.5em;
    line-height: 1.25;
    margin-top: 0.5rem;
}
.question__answers.question__answers--answer{
    padding: 0.6em 2em 1.4em;
    border-radius: 0 0 1.5em 1.5em;
    background: #161616;
}
.answer__next{
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    padding: 3.05em 0.6em;
}
.answer__nextText{
    width: 100%;
    line-height: 1.333;
    font-size: 0.9375em;
    margin-bottom: 2.1em;
}
.answer__nextBtn{
    width: 8.625em;
}
@media(min-width: 100vh){
    .answer{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }
    .question__answers.question__answers--answer{
        width: 100%;
        padding: 0;
        justify-content: center;
        background: transparent;
        border-radius: 0;
        order: -1;
    }
    .answer__content{
        color: #000;
        background: #fff;
        border-radius: 1.25em;
        width: 15.625em;
        margin: 0 1.0625em;
        padding: 1.6875em 1.375em;
        min-height: 20.6em;
    }
    .answer__next{
        width: 15.625em;
        background: #161616;
        border-radius: 1.25em;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 3.3em 1.2em 1.6em;
    }
    .answer__grid{
        width: 15.625em;        
    }
    .answer__top{
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 0.9em;
    }
    .answer__ava{
        margin: 0 0 0.55em;
    }
    .answer__name{
        padding: 0 0.125rem;
        font-weight: 700;
        max-width: 6.7em;
    }
    .answer__top+.question__text{
        padding: 0 0.125rem;
    }
    .answer__nextText{
        margin: auto;
    }
    .answer__nextBtn{
        width: 100%;
        margin-top: 1em;
    }
}`, "",{"version":3,"sources":["webpack://./src/routes/Answer/answer.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,cAAc;AAClB;AACA;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,eAAe;IACnB;IACA;QACI,WAAW;QACX,UAAU;QACV,uBAAuB;QACvB,uBAAuB;QACvB,gBAAgB;QAChB,SAAS;IACb;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,qBAAqB;QACrB,eAAe;QACf,kBAAkB;QAClB,yBAAyB;QACzB,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,mBAAmB;QACnB,qBAAqB;QACrB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,0BAA0B;IAC9B;IACA;QACI,eAAe;IACnB;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,oBAAoB;IACxB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;QACX,eAAe;IACnB;AACJ","sourcesContent":[".answer__content{\n    padding: 0.625em 1.25em;\n    border-radius: 1.5em 1.5em 0 0;\n    background: #161616;\n}\n.answer__top{\n    display: flex;\n    align-items: center;\n    margin-bottom: 1em;\n}\n.answer__ava{\n    position: relative;\n    border-radius: 100%;\n    background: #D7D3F1;\n    width: 5.875em;\n    height: 5.875em;\n    flex-shrink: 0;\n    margin-right: 1.2em;\n}\n.answer__avaIco{\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%; \n}\n.answer__name{\n    font-weight: 500;\n    font-size: 1.5em;\n    line-height: 1.25;\n    margin-top: 0.5rem;\n}\n.question__answers.question__answers--answer{\n    padding: 0.6em 2em 1.4em;\n    border-radius: 0 0 1.5em 1.5em;\n    background: #161616;\n}\n.answer__next{\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n    padding: 3.05em 0.6em;\n}\n.answer__nextText{\n    width: 100%;\n    line-height: 1.333;\n    font-size: 0.9375em;\n    margin-bottom: 2.1em;\n}\n.answer__nextBtn{\n    width: 8.625em;\n}\n@media(min-width: 100vh){\n    .answer{\n        display: flex;\n        justify-content: center;\n        flex-wrap: wrap;\n    }\n    .question__answers.question__answers--answer{\n        width: 100%;\n        padding: 0;\n        justify-content: center;\n        background: transparent;\n        border-radius: 0;\n        order: -1;\n    }\n    .answer__content{\n        color: #000;\n        background: #fff;\n        border-radius: 1.25em;\n        width: 15.625em;\n        margin: 0 1.0625em;\n        padding: 1.6875em 1.375em;\n        min-height: 20.6em;\n    }\n    .answer__next{\n        width: 15.625em;\n        background: #161616;\n        border-radius: 1.25em;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding: 3.3em 1.2em 1.6em;\n    }\n    .answer__grid{\n        width: 15.625em;        \n    }\n    .answer__top{\n        flex-direction: column;\n        align-items: flex-start;\n        margin-bottom: 0.9em;\n    }\n    .answer__ava{\n        margin: 0 0 0.55em;\n    }\n    .answer__name{\n        padding: 0 0.125rem;\n        font-weight: 700;\n        max-width: 6.7em;\n    }\n    .answer__top+.question__text{\n        padding: 0 0.125rem;\n    }\n    .answer__nextText{\n        margin: auto;\n    }\n    .answer__nextBtn{\n        width: 100%;\n        margin-top: 1em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
